import dayjs from "dayjs";

const baseDate = dayjs().startOf("day");

const ordersDefaultFilters = {
  createDateStartDate: baseDate.subtract(1, "month").toDate(),
  createDateEndDate: baseDate.toDate(),
  createDateType: "past30Days",
};

export default ordersDefaultFilters;
